import { NativeStackNavigationProp, createNativeStackNavigator } from "@react-navigation/native-stack";

import { headerScreenOptions } from "../../components/HeaderBackButton";
import { ParamList } from "./types";
import DuesSummaryScreen from "./DuesSummaryScreen";
import DuesOverviewScreen from "./DuesOverviewScreen";
import DuesReviewScreen from "./DuesReviewScreen";
import AssignProxyScreen from "./AssignProxyScreen";
import { ScreenProps } from "../types";
import { gql, useQuery } from "@apollo/client";
import { ActivityIndicator, Text } from "react-native-paper";
import { Platform, View } from "react-native";
import { Button, PopOver } from "../../components";
import { useIntercom } from "../../hooks";
import config from "../../config";

const Stack = createNativeStackNavigator<ParamList>();

export const DUES_QUERY = gql`
  query DuesQuery {
    duesCycle: currentDuesCycle {
      id
      order {
        id
        payable
      }
    }
  }
`;
interface DuesQuery {
  duesCycle: {
    order?: {
      payable: boolean;
    };
  };
}

export const OrderNotAvailablePopOver = ({
  navigation,
  isProxy,
}: {
  isProxy?: boolean;
  navigation: NativeStackNavigationProp<any>;
}) => {
  const intercom = useIntercom();
  function navigateBack() {
    if (Platform.OS === "web") {
      window.location.assign(isProxy ? `https://${config.accountDomain}` : "/member");
    } else {
      navigation.goBack();
    }
  }

  return (
    <PopOver visible onDismiss={navigateBack} size="md">
      <Text className="text-regular-tight font-700 mb-3">Dues order not found</Text>
      <Text className="text-regular-normal font-400">
        Your dues order may have been paid, canceled, or changed. If you believe this is an error{" "}
        <Text className="underline text-primary" onPress={() => intercom.presentMessageComposer()}>
          contact member services
        </Text>
        .
      </Text>
      <View className="flex-row justify-end mt-6">
        <Button mode="secondary" size="small" onPress={navigateBack}>
          Close
        </Button>
      </View>
    </PopOver>
  );
};

export default function DuesScreen({ route }: ScreenProps<"Dues">) {
  const { assignProxy } = route.params || {};

  const { data } = useQuery<DuesQuery>(DUES_QUERY);

  if (!data?.duesCycle) {
    return <ActivityIndicator className="mt-10 flex-1 items-center justify-center bg-white" />;
  }

  return (
    <Stack.Navigator id="Dues" screenOptions={headerScreenOptions}>
      {data.duesCycle.order?.payable ? (
        <>
          <Stack.Screen
            name={assignProxy ? "DuesProxyOverview" : "DuesOverview"}
            component={DuesOverviewScreen}
            options={{ title: "Dues Payment" }}
          />
          <Stack.Screen
            name={assignProxy ? "DuesProxyReview" : "DuesReview"}
            component={DuesReviewScreen}
            options={{ title: "Verify Information" }}
          />
          <Stack.Screen name="AssignProxy" component={AssignProxyScreen} options={{ title: "Assign Proxy" }} />
          <Stack.Screen name="DuesSummary" component={DuesSummaryScreen} options={{ title: "Dues Summary" }} />
        </>
      ) : (
        <Stack.Screen name="DuesOverview" component={OrderNotAvailablePopOver} options={{ title: "Dues" }} />
      )}
    </Stack.Navigator>
  );
}
